import { render, staticRenderFns } from "./WaitModal.vue?vue&type=template&id=70681961&"
import script from "./WaitModal.vue?vue&type=script&lang=ts&"
export * from "./WaitModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports